 
class SearchAccountingSession {

  constructor() {
    this.id = undefined;
    this.timeStamp = undefined;
    this.sessionId = undefined;
    this.patientId = undefined;
    this.therapistId = undefined;
    this.accountingTherapistHourId = undefined;
    this.isPaidFor = undefined;
    this.appointmentId = undefined;
    this.accountingEntryId = undefined;
    
    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined
    }

  }
}
export default SearchAccountingSession;